import { formatFileSize } from './utils';

const messages = {
  _default: (field: any) => `El campo ${field} no es válido.`,
  after: (field: any, [target, inclusion]: any) =>
    `El campo ${field} debe ser posterior ${
      inclusion ? 'o igual ' : ''
    }a ${target}.`,
  alpha: (field: any) => `El campo ${field} solo debe contener letras.`,
  alpha_dash: (field: any) =>
    `El campo ${field} solo debe contener letras, números y guiones.`,
  alpha_num: (field: any) =>
    `El campo ${field} solo debe contener letras y números.`,
  alpha_spaces: (field: any) =>
    `El campo ${field} solo debe contener letras y espacios.`,
  before: (field: any, [target, inclusion]: any) =>
    `El campo ${field} debe ser anterior ${
      inclusion ? 'o igual ' : ''
    }a ${target}.`,
  between: (field: any, [min, max]: any) =>
    `El campo ${field} debe estar entre ${min} y ${max}.`,
  confirmed: (field: any) => `El campo ${field} no coincide.`,
  credit_card: (field: any) => `El campo ${field} es inválido.`,
  date_between: (field: any, [min, max]: any) =>
    `El campo ${field} debe estar entre ${min} y ${max}.`,
  date_format: (field: any, [format]: any) =>
    `El campo ${field} debe tener formato formato ${format}.`,
  decimal: (field: any, [decimals = '*'] = []) =>
    `El campo ${field} debe ser numérico y contener ${
      decimals === '*' ? '' : decimals
    } puntos decimales.`,
  digits: (field: any, [length]: any) =>
    `El campo ${field} debe ser numérico y contener exactamente ${length} dígitos.`,
  dimensions: (field: any, [width, height]: any) =>
    `El campo ${field} debe ser de ${width} píxeles por ${height} píxeles.`,
  email: (field: any) =>
    `El campo ${field} debe ser un correo electrónico válido.`,
  excluded: (field: any) => `El campo ${field} debe ser un valor válido.`,
  ext: (field: any) => `El campo ${field} debe ser un archivo válido.`,
  image: (field: any) => `El campo ${field} debe ser una imagen.`,
  included: (field: any) => `El campo ${field} debe ser un valor válido.`,
  integer: (field: any) => `El campo ${field} debe ser un entero.`,
  ip: (field: any) => `El campo ${field} debe ser una dirección ip válida.`,
  length: (field: any, [length, max]: any) => {
    if (max) {
      return `El largo del campo ${field} debe estar entre ${length} y ${max}.`;
    }

    return `El largo del campo ${field} debe ser ${length}.`;
  },
  max: (field: any, [length]: any) =>
    `El campo ${field} no debe ser mayor a ${length} caracteres.`,
  max_value: (field: any, [max]: any) =>
    `El campo ${field} debe de ser ${max} o menor.`,
  mimes: (field: any) =>
    `El campo ${field} debe ser un tipo de archivo válido.`,
  min: (field: any, [length]: any) =>
    `El campo ${field} debe tener al menos ${length} caracteres.`,
  min_value: (field: any, [min]: any) =>
    `El campo ${field} debe ser ${min} o superior.`,
  numeric: (field: any) =>
    `El campo ${field} debe contener solo caracteres numéricos.`,
  regex: (field: any) => `El formato del campo ${field} no es válido.`,
  required: (field: any) => `El campo ${field} es obligatorio.`,
  size: (field: any, [size]: any) =>
    `El campo ${field} debe ser menor a ${formatFileSize(size)}.`,
  url: (field: any) => `El campo ${field} no es una URL válida.`,
};

export const validateLocaleEs = {
  name: 'es',
  messages,
  attributes: {},
};
